import React from 'react';
import ToContactButton from './ToContactButton';

const Product = (props) => (
    <div  className="prodtemplate">
        {props.image &&
            <div>
                <div className="ml-5 pl-5 pt-5 prodlabelbar">
                    <h1 className="pl-4">{props.header}<span className="ml-5" ><img className="prodlogoheader" src={props.logo}/></span></h1>
                </div>
                <div>
                    <div className="row ml-5 mt-5">
                        <div className="col-5">
                                <img src={props.image} className="prodimg" alt=''/>
                                {props.image2 && <image src={props.image2} className="prodimg2" alt=''/>}
                        </div>
                        <div className=" col-6 pt-5">
                            <div className="pt-2 proddesc">
                                <ul>
                                    <li>
                                        <p>{props.description[0]}</p>
                                    </li>
                                    {props.description.length > 1 &&
                                    <li className="pt-1">
                                        <p>{props.description[1]}</p>
                                    </li>
                                    }
                                    {props.description.length > 2 &&
                                    <li className="pt-1"> 
                                        <p>{props.description[2]}</p>
                                    </li>
                                    }
                                    {props.description.length > 3 &&
                                    <li className="pt-1">
                                        <p>{props.description[3]}</p>
                                    </li>
                                    }
                                    {props.description.length > 4 &&
                                    <li className="pt-1">
                                        <p>{props.description[4]}</p>
                                    </li>
                                    }
                                    {props.description.length > 5 &&
                                    <li className="pt-1">
                                        <p>{props.description[5]}</p>
                                    </li>
                                    }
                                    {props.description.length > 6 &&
                                    <li className="pt-1">
                                        <p>{props.description[6]}</p>
                                    </li>
                                    }
                                </ul>
                            </div>
                            <div className="prodcontact mt-5">
                                <ToContactButton />
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        {props.file &&
            <object data={props.file} type="application/pdf" className='prodpage' width='101%' height='101%' aria-label='additional product information'/>
        }
    </div>)

    
export default Product